/*
 * A row's subject without its campaign's name where the row already shows that name (step 10, round
 * 2). Cold outbound subjects open with the campaign ("Payments audit Q4: a review for Harbour
 * Ledger?"), so cut to a 320 px list every row of a campaign read the same, and the campaign chip
 * said it again (critique of 2026-10-18, #1). What is left is what tells the rows apart, its first
 * letter capitalised where it was not, for display only. A reply's "Re:" stays; a subject that is only
 * the campaign's name stays whole. Pure: the browser and its tests share it.
 */

/** "Re:", "Fwd:" and the like, as many as a thread has stacked up. */
const REPLY_PREFIX = /^(?:(?:re|fwd?|aw|sv|wg)\s*:\s*)*/iu;
/** What may join the campaign's name to the rest: a colon, a dot, a dash or a bar, and spaces. */
const JOIN = /^\s*[:·•|–—-]?\s*/u;

export function rowSubject(subject: string, campaignName: string, campaignShown: boolean): string {
  const name = campaignName.trim();
  if (!campaignShown || name === "") return subject;
  const prefix = REPLY_PREFIX.exec(subject)?.[0] ?? "";
  const rest = subject.slice(prefix.length);
  if (rest.slice(0, name.length).toLocaleLowerCase() !== name.toLocaleLowerCase()) return subject;
  const after = rest.slice(name.length);
  // The name must end where a word does: "Q4" is not the start of "Q42".
  if (after !== "" && /^[\p{L}\p{N}]/u.test(after)) return subject;
  const remainder = after.replace(JOIN, "").trim();
  if (remainder === "") return subject;
  // "a review for …" left by the cut reads as a fragment; the row shows it as a subject.
  const shown = /^\p{Ll}/u.test(remainder)
    ? `${remainder.charAt(0).toLocaleUpperCase()}${remainder.slice(1)}`
    : remainder;
  return `${prefix}${shown}`;
}
